<template>
  <div class="relative w-full">
    <div
      :class="[
        'relative flex items-center rounded-md ',
        hasErrors ? 'border border-red-500' : 'border border-gray-400',
        bgColor,
      ]"
    >
      <input
        :id="id"
        ref="input"
        v-model="modelValue"
        v-maska
        :aria-invalid="hasErrors"
        :aria-required="required"
        :class="[
          'w-full border-none bg-transparent p-4 font-sans text-md font-normal text-gray-600 outline-none placeholder:font-sans placeholder:font-normal placeholder:text-gray-600',
          hasErrors ? 'placeholder:text-red-500' : 'placeholder:text-gray-600',
        ]"
        :data-maska="dataMaska"
        :name="name"
        :placeholder="placeholder"
        :readonly="readonly"
        :required="required"
        :type="type"
        v-bind="$attrs"
      />

      <label
        v-if="placeholder && !noLabel"
        :class="bgColor"
        :for="id"
        class="pointer-events-none absolute left-2 top-0 z-30 -translate-y-1/2 px-2 font-sans text-sm font-normal text-anthracite-600"
        style="line-height: 1.2"
      >
        {{ placeholder }}
      </label>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, useId, useTemplateRef } from 'vue'
import { vMaska } from 'maska/vue'
// import { useElementSize } from '@vueuse/core'

defineOptions({ inheritAttrs: false })

const {
  type = 'text',
  mask = '',
  required = false,
  hasErrors = false,
  noLabel = false,
  placeholder = '',
  // Disabling unimport/auto-insert here due misdetection of "readonly" keyword
  // eslint-disable-next-line unimport/auto-insert
  readonly = false,
  name,
  bgColor = 'bg-white',
} = defineProps<{
  placeholder?: string
  mask?: string | string[]
  required?: boolean
  type?: HTMLInputElement['type']
  readonly?: boolean
  name?: string
  noLabel?: boolean
  hasErrors?: boolean
  bgColor?: string
}>()

const modelValue = defineModel<string>()

const input = useTemplateRef('input')
// const { width: inputWidth } = useElementSize(input)

const id = computed(() => `text-input-${useId()}`)

const dataMaska = computed(() => {
  // Maska don't accept array for the dynamic mask approach.
  // String conversion is needed in order to make it work properly
  return Array.isArray(mask) ? JSON.stringify(mask) : mask
})
</script>
